// src/app/containers/Features/containers/User/redux/slice.ts
import { PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveTabEnum,
  UserActivity,
  UserStatusEnum,
} from "app/containers/Features/containers/User/types";
import { createSlice } from "utils/@reduxjs/toolkit";
import { initialState } from "./initialState";


const userDetailsSlice = createSlice({
  name: "userDetailsState",
  initialState: initialState,
  reducers: {
   
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    }, 
    setActiveTab(state, action: PayloadAction<ActiveTabEnum>) {
      state.activeTab = action.payload;
    },
    setSelectedMember(state, action: PayloadAction<{ id: string }>) {
      state.selectedMemberId = action.payload.id;
    },
    setFilters(state, action: PayloadAction<{ value: string | string[]; key: string }>) {
      state.loading = true;
      state.activities.filters[action.payload.key] = action.payload.value;
    },
    setActivitiesLoading(state, action: PayloadAction<boolean>) {
      state.activities.loading = action.payload;
    },
    fetchActivities(state, action: PayloadAction<{ id: string }>) {
      state.activities.loading = true;
    },

    setActivities(state, action: PayloadAction<UserActivity[]>) {
      state.activities.data = action.payload;
    },
    setActivitiesFilter(
      state,
      action: PayloadAction<{ value: string | string[]; key: string }>
    ) {
      state.loading = false;
      state.activities.filters[action.payload.key] = action.payload.value;
    },
    updateUserStatus(
      state,
      _action: PayloadAction<{ status: UserStatusEnum; teamMemberId: string }>,
    ) {},
    fetchUserStatus(
      state,
      _action: PayloadAction<{ userId: string; teamMemberId: string }>,
    ) {
      state.userStatus = null;
    },
    setUserStatus(state, action: PayloadAction<UserStatusEnum>) {
      state.userStatus = action.payload;
    },
  },
});
export const {
  actions,
  reducer: userDetailsReducer,
  name: userDetailsSliceKey,
} = userDetailsSlice;
